module.exports = __webpack_public_path__ + "f57e2766dfbd4eae5d6937ace33be78e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/beard-santa-s.png
// module id = 1793
// module chunks = 0